<template>
  <div>
    <div class="card columns main__search">
      <div class="column is-4 is-offset-4 has-text-centered">
        <img
          src="https://i.postimg.cc/nLmT08ZT/cz-M6-Ly9t-ZWRp-YS1wcml2-YXRl-Lm-Nhbn-Zh-Lm-Nvb-S9-WWVZGSS9-NQUZy-YXl-WWVZGSS8x-L3-Auc3-Zn.png"
          alt=""
        />
      </div>

      <b-field
        label="Search for a course"
        class="column is-4 is-offset-4 has-text-centered"
      >
        <b-autocomplete
          rounded
          open-on-focus
          v-model="filter.title"
          :data="filteredTitleArray"
          icon="magnify"
          clearable
          @select="(option) => (selected = option)"
        >
          <template #empty>No results found</template>
        </b-autocomplete>
      </b-field>

      <div class="column is-10 is-offset-1 columns">
        <b-field
          label="Search for an university"
          class="column is-6 has-text-centered"
        >
          <b-autocomplete
            rounded
            v-model="filter.universityInput"
            field="title"
            icon="magnify"
            open-on-focus
            :data="universities"
            clearable
            @select="(option) => selectUniversity(option)"
            @typing="queryUniversities"
          >
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  <img width="32" :src="props.option.img_url" />
                </div>
                <div class="media-content">
                  {{ props.option.title }}
                  <br />
                  <br />
                </div>
              </div>
            </template>
          </b-autocomplete>
        </b-field>

        <b-field
          label="Search for a location"
          class="column is-6 has-text-centered"
        >
          <b-autocomplete
            rounded
            open-on-focus
            v-model="filter.universityLocation"
            :data="filteredAddressArray"
            icon="magnify"
            clearable
            @select="(option) => selectUniversityAddress(option)"
          >
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  <img width="32" :src="props.option.img_url" />
                </div>
                <div class="media-content">
                  {{ props.option.address }}
                  <br />
                  <br />
                </div>
              </div>
            </template>
            <template #empty>No results found</template>
          </b-autocomplete>
        </b-field>
      </div>

      <div class="column has-text-centered">
        <b-checkbox class="column" v-model="filter.standard_route">
          Non-standard route
        </b-checkbox>

        <b-checkbox class="column" v-model="filter.show_closed">
          Show Closed courses
        </b-checkbox>

        <b-checkbox
          v-if="isManagement"
          class="column"
          v-model="filter.show_invalid"
        >
          Show Invalid courses
        </b-checkbox>

        <b-checkbox v-model="filter.hide_colors">
          {{ filter.hide_colors ? 'Hide' : 'Show' }} courses deadline colors
        </b-checkbox>
      </div>

      <div class="column is-4 is-offset-4 has-text-centered">
        <label class="label"> Timetable Options: </label>
        <b-checkbox
          class="column"
          v-for="(timetable, index) in filterOptions.timetable_options"
          v-bind:key="index"
          v-model="filter.timetable_options"
          :native-value="timetable"
        >
          {{ timetable }}
        </b-checkbox>
      </div>

      <div class="column is-full has-text-centered">
        <p>
          We have found <b>{{ courses.length }}</b> courses that fit the chosen
          criteria
        </p>
      </div>

      <div class="column is-full has-text-centered">
        <b-button rounded @click="queryFilters(true)" type="is-primary"
          >Find course</b-button
        >
        <b-button
          v-if="previousStudent"
          rounded
          class="ml-4"
          @click="selectCourse(null)"
          type="is-primary"
          >Close search</b-button
        >
        <b-button class="mx-4" rounded @click="resetQuery"
          >Reset search</b-button
        >
        <b-button rounded type="is-primary" @click="viewExcel = true"
          >View Excel with universities</b-button
        >
      </div>
    </div>

    <b-modal v-model="isSearchModalActive" full-screen has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head search-modal-header">
          <b-button
            rounded
            v-if="checkedRows.length"
            style="margin-right: 15px"
            @click="bulkUpdate"
            type="is-primary"
            >Bulk update courses</b-button
          >
          <b-button
            rounded
            v-if="checkedRows.length"
            style="margin-right: 15px"
            @click="bulkDelete"
            type="is-danger"
            >Bulk delete courses</b-button
          >
          <b
            class="search-modal-header__close"
            @click.prevent="closeSearchModal()"
          >
            Close search results
            <b-icon
              icon="close-circle"
              size="is-medium"
              type="is-danger"
              style="cursor: pointer"
            >
            </b-icon>
          </b>
        </header>

        <b-table
          class="modal-card-body"
          :checkable="isManagement"
          :checked-rows.sync="checkedRows"
          mobile-cards
          sticky-header
          :data="courses"
          :row-class="(row, index) => this.rowStatus(row)"
        >
          <b-table-column field="title" label="Course name" v-slot="props">
            {{ props.row.title }}
          </b-table-column>

          <b-table-column
            field="university.title"
            label="University"
            v-slot="props"
          >
            <p class="university-title">
              {{ props.row.university.title }}
              <a
                v-if="props.row.university.docs_url"
                :href="props.row.university.docs_url"
                target="_blank"
              >
                <img
                  src="https://www.svgrepo.com/show/525480/question-circle.svg"
                  alt=""
                />
              </a>
            </p>
          </b-table-column>

          <b-table-column field="city" label="City" v-slot="props">
            {{ getCity(props.row.university.address) }}
          </b-table-column>

          <b-table-column field="deadline" label="Deadline" v-slot="props">
            {{ props.row.deadline }}
          </b-table-column>

          <b-table-column field="standard_route" label="Route" v-slot="props">
            {{ props.row.standard_route }}
          </b-table-column>

          <b-table-column field="timetable" label="Delivery" v-slot="props">
            <b-tooltip
              type="is-light"
              :triggers="['click']"
              multilined
              :auto-close="['outside', 'escape']"
            >
              <template v-slot:content>
                {{ props.row.timetable }}
              </template>
              <b-icon
                title="Full Calendar"
                style="cursor: pointer"
                icon="calendar"
                type="is-success"
                size="is-small"
              ></b-icon>
            </b-tooltip>
            <b> {{ formatDocuments(props.row.timetable_options) }} </b>
          </b-table-column>

          <b-table-column
            field="actions"
            label="Actions"
            v-slot="props"
            width="380"
          >
            <div v-if="!isManagement && !previousStudent">
              <b-button
                @click="quickApply(props.row.id)"
                type="is-success"
                style="margin-right: 20px"
              >
                Quick apply
              </b-button>
            </div>

            <b-button
              v-if="isManagement && !previousStudent"
              tag="router-link"
              :to="'/course/' + props.row.id"
              type="is-success"
              style="margin-right: 20px"
            >
              Edit
            </b-button>
            <b-button
              v-if="isAdmin && !previousStudent"
              @click="deleteCourse(props.row.id)"
              type="is-danger"
              style="margin-right: 20px"
              >Delete</b-button
            >
            <b-button
              v-if="previousStudent"
              @click="selectCourse(props.row)"
              type="is-success"
            >
              Select for student
            </b-button>
            <b-button
              v-if="isManagement && props.row.groupRules"
              @click="openGroupSidebar(props.row.groupRules)"
              style="margin-right: 20px"
            >
              View Rule
            </b-button>
            <b-tooltip
              type="is-light"
              :triggers="['click']"
              multilined
              :auto-close="['outside', 'escape']"
              position="is-left"
            >
              <template v-slot:content>
                <ul>
                  <li
                    v-for="(document, index) in props.row.documents"
                    v-bind:key="index"
                  >
                    {{ document }}
                  </li>
                </ul>
              </template>
              <b-button label="Documents" type="is-light" />
            </b-tooltip>
          </b-table-column>
        </b-table>
      </div>
    </b-modal>

    <b-modal
      v-model="isApplyModalActive"
      @close="applyCourse(null, [])"
      :width="1240"
    >
      <student-list
        :courseId="courseId"
        :courseRequirements="courseRequirements"
      ></student-list>
    </b-modal>

    <b-modal v-model="viewExcel" full-screen has-modal-card>
      <div class="modal-card modal-card__excel">
        <iframe
          src="https://docs.google.com/spreadsheets/d/e/2PACX-1vS8qrRGh0nArFVpxs3DCfqBhvi4QGjkVU8pMqrQ0WBN9F3PzulbUZFppANTiOCmV9wmzTSite4MKESo/pubhtml?widget=true&amp;headers=false"
        ></iframe>
      </div>
    </b-modal>

    <b-sidebar
      class="uni-groups__sidebar"
      type="is-light"
      fullheight
      right
      v-model="rulesSidebar.isOpen"
      :can-cancel="false"
    >
      <b-field label="Rule name" class="column is-full">
        <b-input
          v-model="rulesSidebar.activeName"
          type="text"
          name="rules_name"
        ></b-input>
      </b-field>

      <b-field label="Course deadline" class="column is-full">
        <b-datepicker
          v-if="!deadlineTextMode"
          v-model="rulesSidebar.rules.deadline"
          locale="en-GB"
          :show-week-number="true"
          placeholder="Click to select..."
          icon="calendar-today"
          :icon-right="rulesSidebar.rules.deadline ? 'close-circle' : ''"
          icon-right-clickable
          @icon-right-click="clearDate"
          trap-focus
        >
        </b-datepicker>
        <b-input
          v-else
          v-model="rulesSidebar.rules.deadline"
          type="text"
          name="deadline_text"
        ></b-input>
        <b-icon
          title="Change deadline to text"
          @click.native.prevent="toggleDeadlineTextMode()"
          :icon="deadlineTextMode ? 'toggle-switch' : 'toggle-switch-off'"
          size="is-large"
          type="is-success"
        >
        </b-icon>
      </b-field>

      <b-field label="Student Finance" class="column is-full">
        <b-input
          v-model="rulesSidebar.rules.student_finance"
          type="text"
          name="student_finance"
        ></b-input>
      </b-field>

      <b-field label="Standard or Non-standard route" class="column is-full">
        <b-switch
          v-model="rulesSidebar.rules.standard_route"
          false-value="Standard route"
          true-value="Non-standard route"
          class="column is-full"
        >
          {{ rulesSidebar.rules.standard_route }}
        </b-switch>
      </b-field>

      <b-field label="Timetable" class="column is-full">
        <b-input
          placeholder="Use shift-enter for new line"
          type="textarea"
          v-model="rulesSidebar.rules.timetable"
          name="timetable"
        ></b-input>
      </b-field>

      <b-field label="Admission Proccess" class="column is-full">
        <b-input
          placeholder="Use shift-enter for new line"
          type="textarea"
          v-model="rulesSidebar.rules.admission_process"
          name="timetable"
        ></b-input>
      </b-field>

      <div class="column is-full">
        <label class="label">
          Timetable Options:
          <b-icon
            @click.native.prevent="rulesSidebar.rules.timetable_options = []"
            icon="lock-reset"
            size="is-small"
            type="is-danger"
            title="Reset timetable"
            class="cursor-pointer"
          ></b-icon>
        </label>
        <b-checkbox
          v-for="(timetable, tIndex) in timetableOptions"
          v-bind:key="tIndex"
          v-model="rulesSidebar.rules.timetable_options"
          :native-value="timetable"
        >
          {{ timetable }}
        </b-checkbox>
      </div>

      <div class="column is-full">
        <label class="label"> Documents: </label>
        <b-checkbox
          v-for="(document, dIndex) in customDocuments"
          v-bind:key="dIndex"
          v-model="rulesSidebar.rules.documents"
          :native-value="document.text"
        >
          {{ document.text }}
          <b-icon
            v-if="document.isRemovable"
            @click.native.prevent="removeCustomDocuments(dIndex, document)"
            icon="close"
            size="is-small"
            type="is-danger"
          >
          </b-icon>
        </b-checkbox>
        <b-field
          label="Add custom document"
          class="column is-full no-padding-left"
        >
          <b-input
            v-model="customDocument"
            @keyup.native.enter="addCustomDocument()"
            type="text"
            name="custom_doc"
          ></b-input>
        </b-field>
      </div>

      <div class="uni-groups__sidebar-footer">
        <b-button @click="closeSidebar()" type="is-light" class="status-btn"
          >Cancel</b-button
        >
        <b-button
          @click="saveUniRulesChanges()"
          type="is-success"
          class="status-btn"
          >Save changes</b-button
        >
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import CourseService from '../services/course.service';
import UtilService from '../services/util';
import moment from 'moment';
import UniversityService from '../services/university.service';
import { deadlineCoursesDates, deadlineInvalidDates } from '../models/static';

export default {
  name: 'courses-list',
  props: ['previousStudent'],
  data() {
    return {
      checkedRows: [],
      coursesCopy: [],
      courses: [],
      universities: [],
      universityAddress: [],
      originalUniversities: [],
      isApplyModalActive: false,
      isSearchModalActive: false,
      selectedUniversityOption: false,
      viewExcel: false,
      attachments: [],
      courseId: null,
      courseRequirements: [],
      filter: {
        title: '',
        universityInput: '',
        universityLocation: '',
        timetable_options: [],
        standard_route: false,
        show_closed: false,
        hide_colors: false,
        show_invalid: false,
      },
      filterOptions: {
        title: [],
        university: [],
        timetable_options: [],
      },
      customDocument: '',
      deadlineTextMode: false,
      timetableOptions: ['day', 'evening', 'weekend', 'blended'],
      customDocuments: [
        {
          text: 'Passport',
          isRemovable: false,
        },
        {
          text: 'Diploma+Transcript',
          isRemovable: false,
        },
        {
          text: 'CV',
          isRemovable: false,
        },
        {
          text: 'Non standard route document',
          isRemovable: false,
        },
        {
          text: 'Personal Statement',
          isRemovable: false,
        },
        {
          text: 'Share Code',
          isRemovable: false,
        },
        {
          text: 'Proof of Address',
          isRemovable: false,
        },
        {
          text: 'Ask33 Consent Form',
          isRemovable: false,
        },
        {
          text: 'Checklist',
          isRemovable: false,
        },
        {
          text: 'SFE Pre-Application Screenshot',
          isRemovable: false,
        },
      ],
      rulesSidebar: {
        isOpen: false,
        activeId: null,
        activeName: '',
        rules: {},
      },
    };
  },
  created() {
    this.originalUniversities = UtilService.getUniversities();
    this.universities = UtilService.getUniversities().filter(
      (v, i, a) => a.findIndex((v2) => v2.title === v.title) === i
    );
    this.retrieveCourses();
  },
  watch: {
    filter: {
      handler() {
        this.queryFilters(false);
      },
      deep: true,
    },
  },
  methods: {
    retrieveCourses() {
      this.courses = this.$store.state.application.courses.map((course) => {
        const uniGroupId =
          course.university && course.university.uniGroupRuleId
            ? course.university.uniGroupRuleId
            : null;
        const infoData = uniGroupId
          ? course.university.universityRules.rules
          : JSON.parse(course.templateOptions);
        const deadline = infoData.deadline
          ? infoData.deadline.replace(/"|'/g, '')
          : 'closed';

        return {
          id: course.id,
          title: course.title,
          university: course.university,
          groupRules: uniGroupId ? course.university.universityRules : null,
          ...infoData,
          deadline_days: deadline ? this.convertDeadlineToDays(deadline) : -1,
          deadline,
        };
      });

      this.coursesCopy = this.courses;

      const tOptions = this.courses
        .map((item) => {
          if (item.timetable_options.includes('-')) {
            return null;
          }

          return item.timetable_options;
        })
        .flat(1)
        .filter(Boolean);

      const newTimetableOptions = [...new Set(tOptions)].filter(
        (item) => item !== 'day,blended'
      );

      this.filterOptions = {
        title: [...new Set(this.courses.map((item) => item.title))],
        university: [...new Set(this.courses.map((item) => item.university))],
        timetable_options: newTimetableOptions,
      };

      this.resetQuery();
    },

    formatDate(dateString) {
      return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date(dateString));
    },

    formatDocuments(documents) {
      return documents.join(', ');
    },

    deleteCourse(id) {
      this.$buefy.dialog.confirm({
        message:
          'Are you sure you want to delete course? This action cannot be undone',
        onConfirm: () => {
          CourseService.delete(id).then(() => {
            const indexId = this.courses.indexOf((course) => course.id === id);
            this.courses.splice(indexId, 1);
            this.$buefy.toast.open({
              duration: 3000,
              message: `Course succesfully deleted`,
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        },
      });
    },

    applyCourse(id, documents) {
      this.isApplyModalActive = id !== null;
      this.courseId = id;
      this.courseRequirements = documents;
    },

    async createFile(path, name, type) {
      let response = await fetch(path);
      let data = await response.blob();
      let metadata = {
        type: type,
      };
      return new File([data], name, metadata);
    },

    quickApply(courseID) {
      this.$router.push('/quick-apply/' + courseID);
    },

    selectCourse(course) {
      let selectedValue;
      if (course && course.id) {
        const name = `${course.title} at ${course.university.title} in ${course.university.title}`;
        selectedValue = {
          id: course.id,
          name,
        };
      } else {
        selectedValue = null;
      }
      this.$emit('selectedCourse', selectedValue);
    },

    queryUniversities(queryString) {
      const listToQuery = [...this.originalUniversities].filter(
        (v, i, a) => v.title && a.findIndex((v2) => v2.title === v.title) === i
      );

      this.universities = queryString.length
        ? listToQuery.filter(
            (university) =>
              university &&
              university.title &&
              university.title.toLowerCase().includes(queryString.toLowerCase())
          )
        : listToQuery;
      this.queryFilters(false);
    },

    closeSidebar() {
      this.rulesSidebar = {
        isOpen: false,
        activeId: null,
        activeName: null,
        rules: {},
      };
    },

    saveUniRulesChanges() {
      UniversityService.updateGroupRule({
        id: this.rulesSidebar.activeId,
        name: this.rulesSidebar.activeName,
        rules: {
          ...this.rulesSidebar.rules,
          deadline: !this.deadlineTextMode
            ? moment(this.rulesSidebar.rules.deadline).format('DD-MM-YYYY')
            : this.rulesSidebar.rules.deadline,
        },
      }).then(() => {
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Group Rules have been updated',
          position: 'is-bottom',
          type: 'is-success',
        });
        this.closeSidebar();
      });
    },

    getDeadline(deadline) {
      if (
        deadlineInvalidDates.includes(
          deadline.toLowerCase().replace(/["']/g, '')
        )
      ) {
        this.deadlineTextMode = true;
        return deadline;
      }

      if (
        new Date(deadline).toString() !== 'Invalid Date' ||
        typeof deadline === 'string' ||
        deadline instanceof String
      ) {
        return moment(deadline.replaceAll('-', '/'), 'DD/MM/YYYY').toDate();
      }

      return null;
    },

    openGroupSidebar(group) {
      let rules = {};
      let activeId = group.id;
      let activeName = group.name;

      const parsedRules = group.rules;
      rules = {
        ...parsedRules,
        deadline: this.getDeadline(parsedRules.deadline),
      };

      rules.documents &&
        rules.documents
          .filter(
            (x) =>
              !this.customDocuments.map((document) => document.text).includes(x)
          )
          .forEach((element) => {
            this.customDocuments.push({
              text: element,
              isRemovable: true,
            });
          });

      this.rulesSidebar = {
        isOpen: true,
        activeId,
        activeName,
        rules,
      };
    },

    toggleDeadlineTextMode() {
      this.rulesSidebar.rules.deadline = this.deadlineTextMode
        ? new Date()
        : '';
      this.deadlineTextMode = !this.deadlineTextMode;
    },

    clearDate() {
      this.rulesSidebar.rules.deadline = null;
    },

    addCustomDocument() {
      this.customDocuments.push({
        text: this.customDocument,
        isRemovable: true,
      });
      this.customDocument = '';
    },

    removeCustomDocuments(index, document) {
      const indexToRemoveFromDocs =
        this.rulesSidebar.rules.documents.indexOf(document);

      if (indexToRemoveFromDocs > -1) {
        this.rulesSidebar.rules.documents.splice(indexToRemoveFromDocs, 1);
      }

      this.customDocuments.splice(index, 1);
    },

    queryFilters(showSearchModal) {
      const filter = this.filter;

      function filterTitle(course) {
        return filter.title.length
          ? course.title &&
              course.title.toLowerCase().includes(filter.title.toLowerCase())
          : true;
      }

      function filterUniversity(course) {
        if (!filter.universityInput) {
          return true;
        }

        const uniFilter = filter.universityInput
          .toLowerCase()
          .replace(/ /g, '');
        return filter.universityInput.length &&
          course.university &&
          course.university.title
          ? course.university.title
              .toLowerCase()
              .replace(/ /g, '')
              .includes(uniFilter)
          : true;
      }

      function filterUniversityAddress(course) {
        if (!filter.universityLocation) {
          return true;
        }

        const uniFilter = filter.universityLocation
          .toLowerCase()
          .replace(/ /g, '');
        return filter.universityLocation.length && course.university.address
          ? course.university.address
              .toLowerCase()
              .replace(/ /g, '')
              .includes(uniFilter)
          : true;
      }

      function filterTimetable(course) {
        return filter.timetable_options.length
          ? filter.timetable_options.every((docFilter) =>
              course.timetable_options.includes(docFilter)
            )
          : true;
      }

      function filterRoute(course) {
        return filter.standard_route
          ? course.standard_route === 'Non-standard route'
          : true;
      }

      function filterShowClosed(course) {
        if (!filter.show_closed) {
          return (
            course.deadline_days > 0 ||
            deadlineCoursesDates.includes(course.deadline.toLowerCase())
          );
        }

        return true;
      }

      function filterInvalidCourses(course) {
        return filter.show_invalid ? course.deadline == 'Invalid date' : true;
      }

      this.courses = this.coursesCopy
        .filter(filterTitle)
        .filter(filterUniversity)
        .filter(filterRoute)
        .filter(filterTimetable)
        .filter(filterShowClosed)
        .filter(filterInvalidCourses)
        .filter(filterUniversityAddress);
      localStorage.setItem('hide_colors', this.filter.hide_colors);

      if (showSearchModal) {
        this.isSearchModalActive = true;
      }
    },

    resetQuery() {
      this.filter = {
        title: '',
        universityInput: '',
        universityLocation: '',
        timetable_options: [],
        standard_route: false,
        hide_colors: localStorage.getItem('hide_colors') === 'true',
      };

      this.selectedUniversityOption = false;
      this.queryAdress(this.selectedUniversityOption);
      this.queryFilters(false);
    },

    convertDeadlineToDays(deadline) {
      if (deadline.toLowerCase() === 'closed') {
        return -1;
      } else if (deadline.toLowerCase() === 'tbc') {
        return 999;
      } else if (isNaN(moment(deadline, 'DD-MM-YYYY'))) {
        return 0;
      } else if (!isNaN(moment(deadline, 'DD-MM-YYYY'))) {
        return this.rowDeadline(deadline);
      } else {
        return null;
      }
    },

    rowDeadline(deadline) {
      const deadlineDate = moment(deadline, 'DD-MM-YYYY');
      const now = moment().startOf('day');
      const diffDays = deadlineDate.diff(now, 'days');
      return diffDays;
    },

    rowStatus(row) {
      if (this.filter.hide_colors === true) {
        return '';
      } else if (row.deadline_days > 2 && row.deadline_days < 14) {
        return 'is-warning';
      } else if (row.deadline_days > 14 && row.deadline_days < 30) {
        return 'is-orange';
      } else if (row.deadline_days > 30) {
        return '';
      }
      return 'is-danger';
    },

    getCity(address) {
      return address.substring(0, address.indexOf('-'));
    },

    bulkUpdate() {
      const mappedIds = this.checkedRows.map((row) => row.id);
      this.$router.push({
        name: 'add-course',
        params: {
          mappedIds: mappedIds,
        },
      });
    },

    bulkDelete() {
      const mappedIds = this.checkedRows.map((row) => row.id);

      this.$buefy.dialog.confirm({
        message: `Are you sure you want to delete ${mappedIds.length} courses? This action cannot be undone`,
        onConfirm: () => {
          for (let index = 0; index < mappedIds.length; index++) {
            const id = mappedIds[index];
            const indexId = this.courses.indexOf((course) => course.id === id);
            this.courses.splice(indexId, 1);
          }

          CourseService.delete(mappedIds).then(() => {
            this.$buefy.toast.open({
              duration: 3000,
              message: `Courses succesfully deleted`,
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        },
      });
    },

    closeSearchModal() {
      this.isSearchModalActive = false;
    },

    selectUniversity(option) {
      this.filter.universityInput = option ? option.title : option;
      this.selectedUniversityOption = option ? true : false;
      this.queryAdress(this.selectedUniversityOption);
    },

    queryAdress(shouldQueryList) {
      if (shouldQueryList) {
        this.universityAddress = [...this.originalUniversities].filter(
          (university) =>
            university.title
              .toLowerCase()
              .includes(this.filter.universityInput.toLowerCase())
        );
      } else {
        this.universityAddress = [...this.originalUniversities].filter(
          (v, i, a) => a.findIndex((v2) => v2.address === v.address) === i
        );
      }

      this.queryFilters(false);
    },

    selectUniversityAddress(option) {
      setTimeout(() => {
        this.filter.universityLocation = option ? option.address : option;
      }, 0);
    },
  },
  computed: {
    filteredTitleArray() {
      return this.filterOptions.title.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.filter.title.toLowerCase()) >= 0
        );
      });
    },

    filteredAddressArray() {
      if (!this.filter.universityLocation) {
        return [...this.universityAddress];
      }

      return [...this.universityAddress].filter((option) => {
        return (
          option.address
            .toString()
            .toLowerCase()
            .indexOf(this.filter.universityLocation.toLowerCase()) >= 0
        );
      });
    },

    isManagement() {
      return UtilService.isManagement();
    },

    isAdmin() {
      return UtilService.isAdmin();
    },
  },
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.table td[data-label='Actions'] {
  flex-wrap: wrap;
  max-width: 350px;
  gap: 10px;
}

.tag.is-primary {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-content: flex-start;
}

.b-sidebar .sidebar-content.is-mini {
  width: 60px;
  height: 70px;
}

div.b-table table.table tr {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}

div.b-table table.table tr td {
  border-bottom: none;
  padding: 0.25em;
}

.university-title {
  display: flex;
  align-items: center;
}

.university-title img {
  max-width: 32px;
  display: inline;
}

.search-modal-header {
  justify-content: flex-end;
}

.search-modal-header__close {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-modal-header__close > span {
  margin-left: 12px;
}

.main__search {
  border: none;
  box-shadow: none;
}

.modal-card__excel,
.modal-card__excel iframe {
  height: 100vh;
}

.uni-logo {
  max-width: 80px;
}

.edit_uni_admins {
  display: flex;
  align-items: center;
}

.edit_uni_admins > .field {
  flex: auto;
}

.b-sidebar.uni-groups__sidebar .sidebar-content {
  width: clamp(400px, 500px, 50vw);
  z-index: 999;
}

.uni-groups__sidebar-footer {
  position: fixed;
  bottom: 0;
  background: white;
  padding: 8px 8px 8px 0;
}

.no-padding-left {
  padding-left: 0;
}
</style>
